import React from 'react';
import PropTypes from 'prop-types';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, isInvalid, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

const PasswordForm = (props) => {
    const {
        handleSubmit,
        handleSubmitForm,
        invalid,
        pristine,
        submitting,
        translate,
    } = props;

    return (
        <FormWrapper>
            <form onSubmit={ handleSubmit(handleSubmitForm) }>
                <Section>
                    <Row>
                        <Item>
                            <Field
                                component={ RenderTextInputField }
                                fullWidth={ true }
                                label={ translate('resources.password.fields.password_current') }
                                name='current_password'
                                type='password'
                            />
                        </Item>
                    </Row>

                    <Row>
                        <Item>
                            <Field
                                component={ RenderTextInputField }
                                fullWidth={ true }
                                label={ translate('resources.password.fields.password_new') }
                                name='password'
                                type='password'
                            />
                        </Item>
                    </Row>

                    <Row>
                        <Item>
                            <Field
                                component={ RenderTextInputField }
                                fullWidth={ true }
                                label={ translate('resources.password.fields.password_confirmation') }
                                name='password_confirmation'
                                type='password'
                            />
                        </Item>
                    </Row>
                </Section>

                <Section>
                    <Row>
                        <ButtonWrapper>
                            <SubmitButton
                                disabled={ pristine || submitting || invalid }
                                loading={ submitting }
                            />
                        </ButtonWrapper>
                    </Row>
                </Section>
            </form>
        </FormWrapper>
    );
};

PasswordForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.current_password) {
                errors.password_current = translate('aor.validation.required');
            }

            if (!values.password) {
                errors.password_new = translate('aor.validation.required');
            }

            if (!values.password_confirmation) {
                errors.password_confirmation = translate('aor.validation.required');
            }

            if (values.password !== values.password_confirmation) {
                errors.password_confirmation = translate('forms.invalid.match', { field: translate('resources.password.fields.password_new') });
            }

            return errors;
        },
    }),
);

export default enhance(PasswordForm);



// WEBPACK FOOTER //
// ./src/pages/Security/PasswordForm.js